module.exports = __webpack_public_path__ + "static/img/bg8.47659d7a.webp";